import React from 'react';
import { useParams } from 'react-router-dom';
import '../LegalPages.css'; // A shared CSS file for styling

const PrivacyPolicy = () => {
  const { lang } = useParams();
  // You would paste your HTML content here
  const privacyHtml = `
  <div dir="rtl">
    <h1>מדיניות פרטיות — SeegSoog.com</h1>
    <p><strong>תאריך כניסה לתוקף:</strong> 11 בדצמבר, 2025</p>

    <h2>1. מידע שאנו אוספים</h2>
    <ul>
      <li>פרטי קשר: שם, אימייל, מספר טלפון, קידומת מדינה</li>
      <li>פרטי פרופיל: שם משתמש, מידע לאימות גיל (טווח גילאים או אישור על גיל 18 ומעלה)</li>
      <li>נתוני נכסים: מודעות שנוצרו או נשמרו</li>
      <li>נתונים פיננסיים של נכסים (מסופקים על ידי ספקים): החזר השקעה משוער, הוצאות וכו'.</li>
      <li>נתוני שימוש: דוחות שמורים, בתים שמורים</li>
      <li>העדפות תקשורת ומצב הסכמה לדיוור פרסומי</li>
      <li>נתוני פרופיל השקעות (אם סופקו)</li>
    </ul>

    <h2>2. כיצד אנו משתמשים במידע שלך</h2>
    <ul>
      <li>לאפשר כלים מותאמים אישית לספקים ומשקיעים</li>
      <li>לשפר רישומים, סטטיסטיקות ותכונות פלטפורמה</li>
      <li>להגיב לפניות ובקשות תמיכה</li>
      <li>לשלוח עדכונים והודעות פרסומיות (אם נרשמת)</li>
      <li>לנטר את פעילות הפלטפורמה לצורכי אבטחה ואופטימיזציה</li>
    </ul>

    <h2>3. שיתוף עם צדדים שלישיים</h2>
    <p>אנו לא מוכרים את הנתונים האישיים שלך.</p>
    <p>SeegSoog.com מופעלת על ידי חברת לוג-אין הבית החכם בע"מ, מספר ח.פ. 514147305, ישראל. מדיניות פרטיות זו חלה על פעילות חברת לוג-אין הבית החכם בע"מ באתר SeegSoog.com.</p>
    <p>אנו עשויים לשתף מידע מוגבל עם ספקי שירותים עבור:</p>
    <ul>
      <li>עיבוד תשלומים מאובטח</li>
      <li>משלוח דוא"ל (למשל, איפוס סיסמה, שיתוף דוחות)</li>
      <li>ניתוח וביצועים טכניים</li>
    </ul>

    <h2>4. נתוני משתמש של גוגל ו-OAuth</h2>
    <p>אם תבחר להתחבר באמצעות חשבון גוגל שלך, אנו ניגשים למידע פרופיל בסיסי כפי שהתרת במהלך תהליך ההסכמה. זה כולל את שמך, כתובת האימייל וטווח הגילאים שלך.</p>
    <ul>
      <li><strong>כיצד אנו משתמשים בו:</strong> נתונים אלה משמשים אך ורק ליצירה וניהול של חשבונך, להתאמה אישית של הפרופיל שלך ולווידוא שאתה עומד בדרישת הגיל המינימלית שלנו.</li>
      <li><strong>הגבלת שימוש:</strong> השימוש וההעברה שלנו של מידע שהתקבל מממשקי ה-API של גוגל יעמדו ב<a href="https://developers.google.com/terms/api-services-user-data-policy#limited-use_requirements" target="_blank" rel="noopener noreferrer">מדיניות נתוני המשתמש של שירותי ה-API של גוגל</a>, כולל דרישות השימוש המוגבל. אנו לא משתמשים בנתונים אלה לכל מטרה אחרת.</li>
      <li><strong>שיתוף:</strong> איננו חולקים את נתוני המשתמש שלך בגוגל עם צדדים שלישיים, למעט ככל הנדרש לאבטחה ולספק את פונקציונליות הליבה של הכניסה. החריג היחיד הוא כאשר אתה בוחר לבצע פנייה על רישום נכס. במקרה זה, ורק באישור מפורש שלך, נשתף את <strong>שמך וכתובת האימייל שהתקבלו מגוגל</strong> עם ספק הנכס כדי לאפשר תקשורת. לפרטים נוספים על מה שמשותף, עיין בסעיף "שיתוף מידע בין משתמשים" להלן.</li>
    </ul>

    <h2>5. שיתוף מידע בין משתמשים</h2>
    <p>כדי להקל על עסקאות ותקשורת בפלטפורמה שלנו, אנו חולקים מידע מסוים בין משקיעים וספקים בתנאים ספציפיים:</p>
    <ul>
      <li><strong>בעת ביצוע פנייה על נכס:</strong> באישור מפורש שלך, נשתף את פרטי הקשר שלך (שם, אימייל ומספר טלפון) ואת פרופיל ההשקעות שלך עם ספק הנכס. זה מאפשר לספק ליצור איתך קשר ולהבין את צרכי ההשקעה שלך.</li>
    </ul>

    <h2>6. קובצי Cookie, ניתוח וטכנולוגיות מעקב</h2>
    <p>אנו משתמשים בקובצי Cookie וטכנולוגיות מעקב דומות כדי להפעיל ולהתאים אישית את האתר שלנו. זה כולל קובצי Cookie חיוניים לתפקוד האתר (כמו זכירת פרטי הכניסה או העדפת השפה שלך) וקובצי Cookie אופציונליים לניתוח כדי להבין כיצד משתמשים באתר שלנו.</p>
    <p>באופן ספציפי, אנו משתמשים ב-Google Analytics כדי לאסוף נתונים אנונימיים על תעבורת האתר והתנהגות המשתמשים. זה עוזר לנו לשפר את שירותינו. יש לך שליטה מלאה אם לאפשר קובצי Cookie אלה לניתוח.</p>
    <p>תוכל לנהל את העדפות קובצי ה-Cookie שלך בכל עת דרך מנהל הגדרות ה-Cookie שלנו. להסבר מפורט על קובצי ה-Cookie שאנו משתמשים בהם וכיצד לשלוט בהם, אנא עיין ב<a href="/${lang}/cookie-policy">מדיניות קובצי ה-Cookie</a> שלנו.</p>

    <h2>7. אבטחת מידע</h2>
    <p>הנתונים שלך מוצפנים ומוגנים. פעולות רגישות מנוטרות, וסיסמאות מאוחסנות באופן מאובטח.</p>

    <h2>8. בקרות משתמש</h2>
    <ul>
      <li>עדכן את הפרופיל שלך דרך דף עריכת ההעדפות</li>
      <li>הירשם או בטל הרשמה להודעות דוא"ל פרסומיות</li>
      <li>בקש מחיקת חשבון על ידי פנייה לתמיכה</li>
    </ul>

    <h2>9. פרטיות ילדים</h2>
    <p>השירותים שלנו אינם מיועדים למשתמשים מתחת לגיל 18. איננו אוספים ביודעין נתונים מקטינים.</p>

    <h2>10. עדכוני מדיניות</h2>
    <p>מדיניות פרטיות זו עשויה להתעדכן מעת לעת. אנו נודיע לך דרך האתר או בדוא"ל.</p>

    <h2>11. יצירת קשר</h2>
    <p>לשאלות או בקשות, אנא השתמש בדף <a href="/${lang}/contact-us">צור קשר</a> שלנו.</p>
  </div>
  `;

  return (
    <div className="legal-page-container">
      <div className="legal-content" dangerouslySetInnerHTML={{ __html: privacyHtml }} />
    </div>
  );
};

export default PrivacyPolicy;
